export const courseList = [
  {
    id: 'c001',
    icon: 'ri-heart-2-line',
    color: 'bg-rose-50 text-rose-500',
    accentColor: 'rose',
    title: '婚前辅导课程',
    titleEn: 'Pre-Marriage Counseling',
    instructor: '王心理咨询师',
    instructorTitle: '国家二级心理咨询师 · 15年经验',
    desc: '专业心理咨询师指导，帮助您了解婚姻的本质，建立健康的伴侣关系基础，为幸福婚姻做好准备。',
    lessons: 12,
    duration: '约6小时',
    students: 3200,
    rating: 4.9,
    price: 2,
    originalPrice: 299,
    isFree: true,
    badge: '最受欢迎',
    tags: ['婚前准备', '心理辅导', '关系建立'],
    image: 'https://public.readdy.ai/ai/img_res/2776fbcb2536a39556c3047bd5d81abc.jpg',
  },
  {
    id: 'c002',
    icon: 'ri-discuss-line',
    color: 'bg-amber-50 text-amber-500',
    accentColor: 'amber',
    title: '情感沟通工作坊',
    titleEn: 'Emotional Communication Workshop',
    instructor: '陈情感导师',
    instructorTitle: '婚姻家庭咨询师 · 著有《爱的语言》',
    desc: '学习有效的情感表达与倾听技巧，解决伴侣间的沟通障碍，让爱意流动更顺畅，感情更深厚。',
    lessons: 8,
    duration: '约4小时',
    students: 2800,
    rating: 4.8,
    price: 2,
    originalPrice: 199,
    isFree: true,
    badge: '新课上线',
    tags: ['沟通技巧', '情感表达', '倾听'],
    image: 'https://readdy.ai/api/search-image?query=couple%20having%20meaningful%20conversation%20in%20cozy%20living%20room%20warm%20lighting%20smiling%20understanding%20each%20other%20communication%20workshop%20setting&width=600&height=360&seq=course002&orientation=landscape',
  },
  {
    id: 'c003',
    icon: 'ri-home-heart-line',
    color: 'bg-green-50 text-green-500',
    accentColor: 'green',
    title: '家庭规划指导',
    titleEn: 'Family Planning Guidance',
    instructor: '林家庭顾问',
    instructorTitle: '家庭教育专家 · 清华大学客座讲师',
    desc: '从恋爱到婚姻，从二人世界到三口之家，全程专业指导，助您科学规划幸福家庭的每一步。',
    lessons: 10,
    duration: '约5小时',
    students: 1900,
    rating: 4.7,
    price: 2,
    originalPrice: 249,
    isFree: true,
    badge: null,
    tags: ['家庭规划', '育儿准备', '生活设计'],
    image: 'https://readdy.ai/api/search-image?query=happy%20young%20Chinese%20family%20planning%20together%20at%20home%20table%20with%20notebook%20calendar%20warm%20natural%20light%20cozy%20domestic%20setting&width=600&height=360&seq=course003&orientation=landscape',
  },
  {
    id: 'c004',
    icon: 'ri-mental-health-line',
    color: 'bg-violet-50 text-violet-500',
    accentColor: 'violet',
    title: '情绪管理与自我成长',
    titleEn: 'Emotional Intelligence & Growth',
    instructor: '张心理博士',
    instructorTitle: '心理学博士 · 情商研究专家',
    desc: '提升情商，学会管理情绪，成为更好的自己，在感情中保持理性与温柔，吸引更优质的伴侣。',
    lessons: 6,
    duration: '约3小时',
    students: 4100,
    rating: 4.9,
    price: 2,
    originalPrice: 179,
    isFree: true,
    badge: '好评如潮',
    tags: ['情商提升', '自我成长', '情绪管理'],
    image: 'https://readdy.ai/api/search-image?query=person%20meditating%20peacefully%20in%20bright%20modern%20room%20self%20growth%20mindfulness%20calm%20serene%20atmosphere%20plants%20natural%20light&width=600&height=360&seq=course004&orientation=landscape',
  },
  {
    id: 'c005',
    icon: 'ri-user-heart-line',
    color: 'bg-pink-50 text-pink-500',
    accentColor: 'pink',
    title: '异地恋维系秘籍',
    titleEn: 'Long-Distance Relationship Guide',
    instructor: '刘情感作家',
    instructorTitle: '情感专栏作家 · 500万读者',
    desc: '专为海外华人设计，教您如何跨越时差与距离，用智慧和爱心维系一段真实而深厚的感情。',
    lessons: 7,
    duration: '约3.5小时',
    students: 5600,
    rating: 4.8,
    price: 2,
    originalPrice: 159,
    isFree: true,
    badge: '海外必修',
    tags: ['异地恋', '海外华人', '感情维系'],
    image: 'https://readdy.ai/api/search-image?query=couple%20video%20calling%20on%20laptop%20smiling%20warmly%20across%20distance%20cozy%20room%20warm%20lighting%20emotional%20connection%20technology%20love&width=600&height=360&seq=course005&orientation=landscape',
  },
  {
    id: 'c006',
    icon: 'ri-sparkling-line',
    color: 'bg-orange-50 text-orange-500',
    accentColor: 'orange',
    title: '第一次约会完全指南',
    titleEn: 'First Date Complete Guide',
    instructor: '赵形象顾问',
    instructorTitle: '形象管理师 · 约会礼仪专家',
    desc: '从穿搭到话题，从餐厅选择到告别时机，手把手教您打造完美第一印象，让对方念念不忘。',
    lessons: 5,
    duration: '约2.5小时',
    students: 7200,
    rating: 4.7,
    price: 2,
    originalPrice: 129,
    isFree: true,
    badge: '超高人气',
    tags: ['约会技巧', '形象管理', '第一印象'],
    image: 'https://readdy.ai/api/search-image?query=elegant%20couple%20on%20first%20date%20at%20nice%20restaurant%20candlelight%20romantic%20atmosphere%20smiling%20happy%20well%20dressed%20Chinese%20couple&width=600&height=360&seq=course006&orientation=landscape',
  },
];

export const courseStats = [
  { num: '200+', label: '专业课程', icon: 'ri-book-2-line' },
  { num: '50+', label: '认证讲师', icon: 'ri-user-star-line' },
  { num: '10万+', label: '学员受益', icon: 'ri-group-line' },
  { num: '98%', label: '好评率', icon: 'ri-star-line' },
];
